<template>
  <div>
    <div class="bd-header bd-header_cosmo">
      <div class="bd-header__menu" @click="shift()">
        <svg height="100" viewBox="-38 -38 100 100" width="100" xmlns="http://www.w3.org/2000/svg" v-if="!isMobile" v-bind:svg-inline="''" v-bind:class="'bd-svg-icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M-33-23h90c1.377 0 2.559.488 3.535 1.465S62-19.379 62-18s-.488 2.559-1.465 3.535S58.377-13 57-13h-90c-1.379 0-2.559-.488-3.535-1.465S-38-16.621-38-18s.488-2.559 1.465-3.535S-34.379-23-33-23zm0 60h90c1.377 0 2.559.488 3.535 1.465S62 40.623 62 42s-.488 2.559-1.465 3.535S58.377 47 57 47h-90c-1.379 0-2.559-.488-3.535-1.465S-38 43.377-38 42s.488-2.559 1.465-3.535S-34.379 37-33 37zm0-30h90c1.377 0 2.559.488 3.535 1.465S62 10.621 62 12s-.488 2.559-1.465 3.535S58.377 17 57 17h-90c-1.379 0-2.559-.488-3.535-1.465S-38 13.379-38 12s.488-2.559 1.465-3.535S-34.379 7-33 7z"/></svg>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 123.5 102.7" v-else="" v-bind:svg-inline="''" v-bind:class="'bd-svg-icon'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M47.6 98.1c2.9 2.9 7.7 2.9 10.6 0 2.9-2.9 2.9-7.7 0-10.6L29.4 58.7h83.5c4.1 0 7.5-3.4 7.5-7.5s-3.4-7.5-7.5-7.5H29.4l28.8-28.8c2.9-2.9 2.9-7.7 0-10.6C56.7 2.8 54.8 2 52.9 2s-3.8.7-5.3 2.2L6 45.8c-1.4 1.4-2.2 3.3-2.2 5.3S4.6 55 6 56.4l41.6 41.7z"/></svg>
      </div>
      <div class="bd-header__title bd-ht">
        <img class="bd-ht__img" src="/pages/cosmo/img/logo.svg" alt="">
      </div>
    </div>
    <div class="bd-cosmo">

      <div class="bd-cosmo-menu">
        <span class="bd-cosmo-menu__item">Cosmoконкурс</span>
        <span class="bd-cosmo-menu__item">Новости</span>
        <span class="bd-cosmo-menu__item">Мода</span>
        <span class="bd-cosmo-menu__item">Красота</span>
        <span class="bd-cosmo-menu__item">Звезды</span>
        <span class="bd-cosmo-menu__item">Секс</span>
        <span class="bd-cosmo-menu__item">Форум</span>
      </div>

      <div class="bd-cosmo-info">
        <div class="bd-cosmo-info__item bd-cosmo-info__item_bc bd-cosmo-bc">
          <a href="" class="bd-cosmo-bc__item">Звезды</a>
          <a href="" class="bd-cosmo-bc__item">Новости</a>
        </div>
      </div>

      <div class="bd-cosmo-title">Как сохранить фото на телефоне: карманные подсказки</div>
      <p class="bd-cosmo-title-2">Рассказываем, как сохранять фотографии
        из приложений в галерее смартфона. Актуальные подсказки пригодятся
        твоей бабушке, которая недавно скачала «вотсапп», и другим новичкам.
      </p>
      <div class="bd-cosmo-img">
        <img src="/pages/cosmo/img/1.png" alt="" class="bd-cosmo-img__img">
      </div>
      <h4 class="bd-cosmo-text">Дарья Кабацкис</h4>
      <p class="bd-cosmo-text">Чтобы сохранить фото на&nbsp;телефоне,
        не&nbsp;требуется какого-то особого навыка или феноменальных
        технологических познаний. Смартфоны устроены таким образом,
        чтобы облегчать,
        а&nbsp;не&nbsp;усложнять жизнь пользователям,
        поэтому разобраться во&nbsp;всём довольно просто.
      </p>

      <div class="bd-cosmo-text">
        <buzzCode @ready="ready" :id="id"></buzzCode>
      </div>

      <p class="bd-cosmo-text">В&nbsp;этом материале&nbsp;—
        несколько доступных пошаговых рекомендаций,
        которые помогут тебе быстро научиться
        сохранять изображения из&nbsp;приложений и&nbsp;мессенджеров
        у&nbsp;себя в&nbsp;телефоне.
      </p>

      <h2>Как сохранить фото на телефоне</h2>
      <p class="bd-cosmo-text">Большинство приложений одинаково подходят для&nbsp;работы
        на&nbsp;айфонах и&nbsp;андроидах. Чтобы сохранить фото на&nbsp;телефоне,
        нужно использовать практически одинаковые кнопки или команды.
      </p>
      <h2>Как сохранить фото из&nbsp;Instagram на&nbsp;телефоне</h2>
      <p class="bd-cosmo-text">Для андроида или айфона можно использовать
        следующие универсальные способы:
      </p>
      <div class="bd-cosmo-img">
        <img src="/pages/cosmo/img/2.jpg" alt="" class="bd-cosmo-img__img">
      </div>
      <ol>
        <li>Сохранить скриншот изображения(сделать снимок экрана).</li>
        <li>Сохранить ссылку изображения, скопировав её в «Инстаграме»
          (над фото в приложении есть значок из трёх точек, кликнув
          по которому, можно сохранить ссылку на изображение).
          Затем вставить ссылку в заметки или сообщение,
          после чего появится само фото в полноразмерном формате.
          Кликни по фото, нажми «сохранить». Фотография сохранится
          на телефоне, заняв часть его памяти.</li>
        <li>Установить приложение для&nbsp;скачивания фотографий.</li>
      </ol>
      <p class="bd-cosmo-text">Скачай одно из приложений, используя
        для входа свой логин и пароль от аккаунта в Instagram,
        а далее следуй командам, чтобы сохранять нужные фотографии.
      </p>

      <div class="bd-cosmo-footer">
        <div class="bd-cosmo-footer__logo bd-cosmo-flogo">
          <img src="/pages/cosmo/img/logo.svg" alt="" class="bd-cosmo-flogo__img">
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import buzzCode from '@/components/buzzCode.vue';
import { isMobile } from 'mobile-device-detect';

export default {
  name: 'cosmo',
  data() {
    return {
      isMobile,
    };
  },
  props: {
    id: {
      type: String,
    },
  },
  components: {
    buzzCode,
  },
  methods: {
    ready() {
      this.$emit('ready');
    },
    shift() {
      if (isMobile) {
        this.$emit('shift');
      }
    },
  },
};
</script>

<style scoped lang='stylus'>

fontSize(size, lineHeight)
  font-size ((size*0.0625)rem)
  line-height ((lineHeight/size)em)

img
  display block
  width 100%
  height auto

.bd
  &-header
    transition margin .4s
    display flex
    flex-flow row nowrap
    position fixed
    z-index 99997
    align-items center
    align-content space-around
    width 100%
    height 60px
    &_hide
      margin-top -60px
    &__menu
      width 30px
      height 20px
      margin 15px
      svg
        width 100%
        height 100%
        display block
    &__title
      width 100%
      text-align center
  &-feed
    box-sizing border-box
    width 100%
    height 100%
    min-height 100%
    padding-top 60px
  &-header
    &_cosmo
      border-bottom 1px solid rgba(170,170,170,0.5)
      background-color #303030
      & ^[1]__menu
        fill white
      .bd-ht__img
        width 174px
        height auto
    &__menu
      -webkit-tap-highlight-color transparent
      outline none
  &-svg-icon
    -webkit-tap-highlight-color transparent
    outline none
  &-cosmo
    font-family 'Roboto Condensed', sans-serif
    text-align left
    padding-top 60px
    position relative
    &-menu
      height 54px
      padding 0 10px
      background-color #303030
      white-space nowrap
      overflow-x hidden
      &__item
        padding-right 16px
        fontSize(21,54)
        text-transform uppercase
        text-decoration none
        font-weight 300
        color white
    &-info
      padding 10px 10px 0 10px
      &:after
        content ''
        display block
        clear both
      &__item
        fontSize(13,20)
        text-transform uppercase
        color #aaa
    &-bc
      &__item
        text-decoration none
        color #aaa
        &:after
          content '/'
          padding 0 5px
        &:last-child:after
          content ''
    &-title
      padding 10px
      fontSize(30,34)
      font-weight 700
      text-rendering optimizeSpeed
      color #303030
    &-title-2
      margin 10px
      font 17px 'Roboto Condensed', sans-serif
    &-img
      margin 0 10px
      &__img
        width 100%
        height auto
    &-text
      margin 15px 10px
      font-family Arial, Helvetica, sans-serif
      fontSize(17,22)
      color #303030
      margin-left 10px
    h2
      margin-left 10px
      font 1.77em/1.1 'Roboto Condensed',sans-serif
      font-weight 300
    ol
      list-style none
      counter-reset point
      margin 13px
    li
      margin-bottom 10px
      &:before
        content counter(point)". "
        counter-increment point 1
        font-size 17px
        color #ec008c
        position absolute
        left 13px
    &-footer
      width 100%
      overflow hidden
      padding 15px
      background-color #303030
      color #999
      box-sizing border-box
      &__logo
        float left
        padding-bottom 20px
      &__12
        float right
        fontSize(24,30)
      &__cp
        clear both
        font-family "Times New Roman", "Droid Serif", "Minon Pro Regular", serif
        fontSize(12,15)
    &-flogo
      width 143px
      &__img
        width 100%
        height auto

</style>
